<template>
    <div>
        <v-layout class="mt-4">
            <v-alert
                    dense
                    type="info"
                    width="100%"
                    color="green"
            >
                Türkiye'de toplam <b>{{tableData.length}} Vakıf Üniversitesi</b>'nde <b>{{department}} Bölümü</b> bulunmaktadır.
            </v-alert>
        </v-layout>
        <v-layout>
            <v-flex>
                <v-card>
                    <v-simple-table :fixed-header="true" v-if="tableData.length !== 0">
                        <thead>
                        <tr>
                            <th v-for="header in headers" :key="header.key">
                                <div
                                        v-if="header.key == 'bde_siralamasi'"
                                        @click="firstUniversityControl('bde')"
                                >
                                    {{ header.value }}
                                    <v-icon class="orderIcon" large v-if="order_bde">arrow_drop_up</v-icon>
                                    <v-icon class="orderIcon" large v-else>arrow_drop_down</v-icon>
                                </div>
                                <div
                                        v-else-if="header.key == 'ade_siralamasi'"
                                        @click="firstUniversityControl('ade')"
                                >
                                    {{ header.value }}
                                    <v-icon class="orderIcon" large v-if="order_ade">arrow_drop_up</v-icon>
                                    <v-icon class="orderIcon" large v-else>arrow_drop_down</v-icon>
                                </div>
                                <div v-else-if="header.key == 'index'" class="total_data">Toplam Sayı<br/>{{ tableData.length }}</div>
                                <div v-else>{{ header.value }}</div>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, index) in tableData" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td class="td_universite">{{ item.universite }}</td>
                            <td class="td_burslar">
                                <div v-for="(burs, index) in item.burslar" :key="index">
                                    {{ burs.burs }}
                                </div>
                            </td>
                            <!--                <td>-->
                            <!--                    <div v-for="(burs, index) in item.burslar" :key="index">-->
                            <!--                        {{ burs.bif }}-->
                            <!--                    </div>-->
                            <!--                </td>-->
                            <td class="td_kontenjan">
                                <div v-for="(kontenjan, index) in item.burslar" :key="index">
                                    {{ kontenjan.kontenjan }}
                                </div>
                            </td>
                            <!--                <td>{{ item.toplam_kontenjan }}</td>-->
                            <td class="td_yerlesen_ogrenci">
                                <div v-for="(yerlesen_ogrenci, index) in item.burslar" :key="index">
                                    {{ yerlesen_ogrenci.yerlesen }}
                                </div>
                            </td>
                            <td class="td_genel_doluluk_orani">%{{ item.genel_doluluk_orani }}</td>
                            <!--                <td style="min-width: 120px">-->
                            <!--                    <div v-for="(kismi_gecis, index) in item.burslar" :key="index">-->
                            <!--                        {{ kismi_gecis.kismi_gecis_endeksi }}-->
                            <!--                    </div>-->
                            <!--                </td>-->
                            <td class="td_taban">
                                <div v-for="(taban_puan, index) in item.burslar" :key="index">
                                    {{ taban_puan.taban }}
                                </div>
                            </td>
                            <td class="td_tavan">
                                <div v-for="(tavan_puan, index) in item.burslar" :key="index">
                                    {{ tavan_puan.tavan }}
                                </div>
                            </td>
                            <!--                <td>{{ item.yillik_ucret }}</td>-->
                            <td class="td_yge">{{ item.yge }}×<v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on"><b>YEU*</b></span>
                                </template>
                                <span>Yıllık Eğitim Ücreti</span>
                            </v-tooltip></td>
                            <td class="td_ytg">{{ item.ytg }}×<v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on"><b>YEU*</b></span>
                                </template>
                                <span>Yıllık Eğitim Ücreti</span>
                            </v-tooltip></td>
                            <td class="td_bde">{{ item.bde }}</td>
                            <td class="td_ade">{{ item.ade }}</td>
                            <td class="td_bde_ranking">{{ item.bde_ranking }}</td>
                            <td class="td_ade_ranking">{{ item.ade_ranking }}</td>
                        </tr>
                        </tbody>
                    </v-simple-table>
                </v-card>
            </v-flex>
        </v-layout>
    </div>
</template>
<script>
    export default {
        props: ["tableData", "ranking", "firstUniversity", "firstUniversityText"],
        data() {
            return {
                department: '',
                headers: [
                    {key: "index", value: ""},
                    {key: "universite", value: "Üniversite"},
                    {key: "burs_orani", value: "Burs Oranı (%)"},
                    //{key: "bif", value: "Bursluluk Impact Faktörü (BIF)"},
                    {key: "kontenjan", value: "Kontenjan"},
                    // {key: "toplam_kontenjan", value: "Toplam Kontenjan"},
                    {key: "yerlesen_ogrenci", value: "Yerleşen Öğrenci"},
                    {key: "doluluk_orani", value: "Genel Doluluk Oranı"},
                    // {key: "kge", value: "Kısmi Geçiş Endeksi"},
                    {key: "taban_puan", value: "Taban Puan"},
                    {key: "tavan_puan", value: "Tavan Puan"},
                    // {key: "yillik_ucret", value: "Yıllık Ücret"},
                    {key: "yge", value: "Yıllık Getiri Endeksi (YGE)"},
                    {key: "ytg", value: "Yıllık Toplam Getiri (YTG)"},
                    {key: "bde", value: "Bölüm Doluluk Endeksi (BDE)"},
                    {key: "ade", value: "Akademik Düzey Endeksi (ADE)"},
                    {key: "bde_siralamasi", value: "BDE Sıralaması"},
                    {key: "ade_siralamasi", value: "ADE Sıralaması"}
                ],
                order_bde: true,
                order_ade: true,
            };
        },
        mounted() {
            this.department = this.tableData[0].bolum;
        },
        methods: {
            firstUniversityControl(order) {
                this.ranking(this.tableData, order);
                this["order_"+order] = !this["order_"+order];
                if (!this["order_"+order]) {
                    this.tableData = this.tableData.reverse();
                }
                this.firstUniversity(this.tableData, this.firstUniversityText);
            }
        }
    };
</script>

<style>
    table {
        width: calc(100% - 2px)!important;
    }
    table tbody tr {
        height: 100px;
    }
    .orderIcon {
        position: absolute;
        right: 0;
        top: 25px;
    }
    table tbody tr:nth-of-type(odd) {
        background-color: #f2f2f2;
    }
    table tbody tr:hover {
        background-color: #e3e3e3!important;
    }

    table tbody tr:first-child {
        background-color: #a9d08e;
        border: 1px solid #000!important;
        font-weight: bold;
    }

    table tbody tr:first-child:hover {
        background-color: #91b975 !important;
    }
    table thead tr th {
        padding: 10px 5px!important;
        background-color: #e4e4e4!important;
    }
    table thead tr th div {
        -webkit-border-radius: 24px;
        -moz-border-radius: 24px;
        border-radius: 24px;
        color: #000;
        padding: 5px 15px;
        font-size: 14px;
    }
    table thead tr th:nth-last-child(-n + 2) {
        cursor: pointer;
        background-color: #ef8321!important;
    }
    table tbody tr td:nth-last-child(-n + 2) {
        cursor: pointer;
        background-color: #ffcc9e!important;
        font-weight: bold;
    }

    table thead tr th,
    table tbody tr td {
        text-align: center !important;
    }
    .td_universite {
        width: 200px;
    }
    .td_genel_doluluk_orani {
        width: 150px;
    }
    .td_kontenjan,
    .td_yerlesen_ogrenci,
    .td_taban,
    .td_tavan,
    .td_yge {}
    .td_ytg,
    .td_bde {
        width: 140px;
    }
    .td_burslar,
    .td_ade,
    .td_bde_ranking,
    .td_ade_ranking {
        width: 130px;
    }
    @media only screen and (max-width: 1400px) {
        table {
            width: calc(100% - 2px)!important;
        }
        .orderIcon {
            position: relative;
            right: 0;
            top: 0;
        }
        table thead tr th {
            padding: 10px 2.5px!important;
            background-color: #e4e4e4!important;
        }
        .td_kontenjan,
        .td_yerlesen_ogrenci,
        .td_taban,
        .td_tavan,
        .td_yge {}
        .td_ytg,
        .td_bde,
        .td_universite,
        .td_genel_doluluk_orani,
        .td_burslar,
        .td_ade,
        .td_bde_ranking,
        .td_ade_ranking {
            width: 100px;
        }
    }
</style>
